import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { makeSelectAlgoliaTopicsProcessing } from 'containers/Resources/selectors';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import Button from '@material-ui/core/Button';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
// import RemoveCircle from '@material-ui/icons/RemoveCircle';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from 'components/SearchBar/images/white-search.svg';
import Divider from './Divider';
import CheckboxIcon from './images/checkbox.svg';
import CheckboxCheckedIcon from './images/checkbox-checked.svg';

const styles = theme => ({
  header: {
    display: 'block',
  },
  removeRefinementItem: {
    display: 'flex',
    marginRight: 8,
    alignItems: 'center',
    flexDirection: 'row',
  },
  loading: {
    display: 'block',
    margin: '8px auto',
  },
  removeRefinementLabel: {
    marginRight: 2,
  },
  removeRefinementIcon: {
    color: theme.palette.text.secondary,
    fontSize: '12px',
    cursor: 'pointer',
  },
  searchUnderline: {
    marginBottom: 8,
    marginTop: 8,
    '&:before': {
      borderBottom: `1px solid ${theme.palette.text.secondary} !important`,
    },
    '&:after': {
      borderBottom: `px solid ${theme.palette.text.secondary} !important`,
    },
  },
  showMoreButton: {
    width: '100%',
    color: theme.palette.text.secondary,
  },
  listTextContainer: {
    padding: 0,
    overflowWrap: 'break-word',
  },
  itemContainer: {
    padding: '4px 10px',
    marginBottom: 8,
    marginRight: 4,
    borderRadius: 999,
    border: '2px solid #ddd',
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover': {
      background: '#fafafa',
    },
    display: 'inline-flex',
  },
  selectedItemContainer: {
    padding: '4px 10px',
    marginBottom: 8,
    marginRight: 4,
    borderRadius: 999,
    border: '2px solid #34546E',
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover': {
      background: '#fafafa',
    },
    display: 'inline-flex',
  },
  filteredRefinementListText: {
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#FADA5E',
    fontSize: '0.9rem',
  },
  filteredItemContainer: {
    padding: '4px 10px',
    marginBottom: 8,
    marginRight: 4,
    borderRadius: 999,
    border: '2px solid #FADA5E',
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover': {
      background: '#fafafa',
    },
    display: 'inline-flex',
  },
  inputContainer: {
    background: '#ffffff',
    color: '#000',
    border: '1px solid #E9ECED',
    borderRadius: 3,
    width: '100%',
    height: 40,
    marginTop: 16,
    marginBottom: 8,
  },
  inputRoot: {
    height: '100%',
  },
  input: {
    paddingLeft: 20,
    fontSize: 14,
  },
  iconContainer: {
    background: '#01619B',
    height: 'calc(100% + 2px)',
    width: 52,
    marginRight: -1,
    borderTopRightRadius: 3,
    borderBottomRightRadius: 3,
    display: 'flex',
    justifyContent: 'center',
  },
  icon: {
    height: 23,
    width: 22,
  },
  listContainer: {
    maxHeight: 400,
    overflowY: 'auto',
    paddingRight: 10,
  },
  listItemContainer: {
    padding: 0,
    cursor: 'pointer',
    marginBottom: 4,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  refinementListText: {
    fontSize: 14,
    color: theme.palette.text.primary,
  },
  selectedRefinementListText: {
    fontSize: 14,
    color: theme.palette.primary.main,
  },
  checkbox: {
    padding: 0,
    marginRight: 12,
  },
});

class TopicsRefinementList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      term: '',
    };
  }

  handleQueryChange = e => {
    clearTimeout(this.debouncedSetState);
    const query = e.target.value;
    this.setState({ term: query });

    this.debouncedSetState = setTimeout(() => {
      this.props.onQueryTopics(query);
    }, 400);
  };

  render() {
    const {
      attribute,
      items,
      label,
      // currentSelection,
      hasShowMore,
      showMore,
      // toggleShowMore,
      triggerSelection,
      // clearMultiple,
      processing,
      classes,
      withTitle,
      withDivider,
      placeholder,
    } = this.props;
    const { term } = this.state;
    const sortedItems = items.sort((a, b) => {
      if (a.isSelected && !b.isSelected) return -1;
      if (!a.isSelected && b.isSelected) return 1;
      if (a.isFiltered && !b.isFiltered) return -1;
      if (!a.isFiltered && b.isFiltered) return 1;
      // if (a.value < b.value) return -1;
      // if (a.value > b.value) return 1;
      return 0;
    });

    return (
      <>
        {withDivider && <Divider />}
        {withTitle && (
          <Typography
            variant="caption"
            color="textPrimary"
            className={classes.header}
          >
            {label || attribute}
          </Typography>
        )}
        <TextField
          placeholder={placeholder}
          value={term}
          onChange={this.handleQueryChange}
          classes={{ root: classes.inputContainer }}
          InputProps={{
            disableUnderline: true,
            classes: { root: classes.inputRoot, input: classes.input },
            endAdornment: (
              <InputAdornment position="end" className={classes.iconContainer}>
                <img src={SearchIcon} alt="Search" className={classes.icon} />
              </InputAdornment>
            ),
          }}
        />
        {processing ? (
          <CircularProgress
            className={classes.loading}
            size={24}
            thickness={4}
            disableShrink
          />
        ) : (
          <List classes={{ root: classes.listContainer }}>
            {renderOptions(
              attribute,
              hasShowMore,
              showMore,
              sortedItems,
              triggerSelection,
              classes,
            )}
          </List>
        )}
      </>
    );
  }
}

const renderOptions = (
  attribute,
  hasShowMore,
  showMore,
  sortedItems,
  triggerSelection,
  classes,
) =>
  sortedItems.map(item => (
    <ListItem
      key={item.value}
      onClick={() => triggerSelection(attribute, item.value, item.type)}
      className={classes.listItemContainer}
    >
      <Checkbox
        checked={item.isSelected}
        checkedIcon={
          <img src={CheckboxCheckedIcon} alt={`Checkbox ${item.value}`} />
        }
        icon={<img src={CheckboxIcon} alt={`Checkbox ${item.value}`} />}
        disableRipple
        classes={{ root: classes.checkbox }}
        inputProps={{ 'aria-label': `Checkbox ${item.value}` }}
      />
      <ListItemText
        primary={item.value}
        classes={{
          root: classes.selectedRefinementListText,
          primary: item.isSelected
            ? classes.selectedRefinementListText
            : classes.refinementListText,
        }}
      />
    </ListItem>
  ));

TopicsRefinementList.propTypes = {
  items: PropTypes.array,
  triggerSelection: PropTypes.func,
  onQueryTopics: PropTypes.func,
  hasShowMore: PropTypes.bool,
  showMore: PropTypes.bool,
  processing: PropTypes.bool,
  classes: PropTypes.object,
  attribute: PropTypes.string,
  label: PropTypes.string,
  // currentSelection: PropTypes.array,
  // clearMultiple: PropTypes.func,
  placeholder: PropTypes.string,
  withTitle: PropTypes.bool,
  withDivider: PropTypes.bool,
};

TopicsRefinementList.defaultProps = {
  placeholder: 'Search Topic',
  withTitle: true,
  withDivider: true,
};

const mapStateToProps = createStructuredSelector({
  processing: makeSelectAlgoliaTopicsProcessing(),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withConnect,
  withStyles(styles),
)(TopicsRefinementList);
